// extracted by mini-css-extract-plugin
export default {"firstsection":"First_firstsection__K-gqM","titles":"First_titles__VWXrQ","typing":"First_typing__gDoVx"};